export function getFonts(customFonts = {}, irisTheme = []) {
    const { themes } = customFonts;

    const shouldExcludeFont = (font, irisThemes) => {
        if (!Array.isArray(font.exclude)) {
            return false;
        }

        let len = font.exclude.length;

        /* eslint-disable */
        while (len--) {
            if (irisThemes.indexOf(font.exclude[len]) > -1) {
                return true;
            }

            continue;
        }
        /* eslint-enable */

        return false;
    };

    const fonts = themes.all.filter((font) => !shouldExcludeFont(font, irisTheme));

    irisTheme.reduce((acc, themeId) => {
        const sectionFonts = themes[themeId];

        if (sectionFonts) {
            sectionFonts.forEach((font) => acc.push(font));
        }

        return acc;
    }, fonts);

    return fonts;
}

export function fontsToInlineStyle(fonts = []) {
    return fonts
        .map(
            ({ name, cdn, weight, style }) => `
            @font-face {
                src: url("${cdn}.eot#?iefix") format('embedded-opentype'),
                     url("${cdn}.woff2") format('woff2'),
                     url("${cdn}.woff") format('woff');
                font-family: ${name};
                font-display: fallback;
                font-weight: ${weight};
                font-style: ${style};
            }
        `,
        )
        .join('');
}



/** WEBPACK FOOTER **
 ** ./src/utils/font-chooser.js
 **/